import axios from "axios";
import { buildHeaders } from "@/services/_headers.util";

const API_URL = `${process.env.VUE_APP_API_URL}boards/`;

export default {
  list(params = {}) { return axios.get(API_URL, { params, headers: buildHeaders() }); },
  create(data)      { return axios.post(API_URL, data, { headers: buildHeaders() }); },
  // add get/update/delete as needed
};
